import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xhgxgkda5f: FaireBrandEntity = {
  token: "b_xhgxgkda5f",
  type: "brand",
  name: "Jar Masala",
  avatarUrl:
    "https://cdn.faire.com/fastly/cf0e670b3530f20bf20efecb3eda796d2375f548b8b0542714c8fcc253710e84.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1223087c15b689e74932cddc465de94a57a86404563b05a7b43aabbf7a5d0029.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/cf0e670b3530f20bf20efecb3eda796d2375f548b8b0542714c8fcc253710e84.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1223087c15b689e74932cddc465de94a57a86404563b05a7b43aabbf7a5d0029.jpeg",
  location: "Snellville , GA, USA",
  minimumOrderDollars: 69,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "SINCE 2020\nFrom our family to yours...Rooted in Flavor, Crafted with Purpose\n\nWelcome to Jar Masala! Jar Masala, a purveyor of authentic South Asian spices, tea blends and handcrafted ghee's. Our handcrafted blends are bringing the bold, authentic flavors of South Asia to your kitchen—without the overwhelm. Every blend is made with pure ingredients, imported and locally sourced, then carefully mixed in small batches. We make cooking easy. Whether you’re seasoning veggies or throwing\ntogether a full Indian dish, our blends are designed to take the guesswork out of it. Our everyday essentials like turmeric, cumin, and garam masala upgrade your pantry staples—while our signature recipe blends let you create complex, traditional meals with just one jar. \n\nNo long ingredient lists. No stress. Just flavor.\n\nEach jar is a celebration of heritage, wellness, and the joy of cooking real\nfood with real flavor.\n\nWe are also proud member of the 'Georgia Grown'.\n\nWoman-Owned | No Additives or Preservatives | Handcrafted in the USA\nSharing my culture through spices and teas!",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:52.322Z",
    importedBy: "entity-db-cli",
  },
};
